"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const either_1 = require("../../types/either");
function default_1(project, action) {
  project.qty = action.qty;
  return (0, either_1.right)(project);
}